import {
  GET_PLC_STATUS,
  GET_PLC_STATUS_SUCCESS,
  GET_PLC_STATUS_ERROR,
} from "./actionTypes";

export const getPlcStatus = (token) => {
  return {
    type: GET_PLC_STATUS,
    payload: { token },
  };
};

export const getPlcStatusSuccess = (message, plc_status) => {
  return {
    type: GET_PLC_STATUS_SUCCESS,
    payload: { message, plc_status },
  };
};

export const getPlcStatusError = (message) => {
  return {
    type: GET_PLC_STATUS_ERROR,
    payload: message,
  };
};
